import { createAction } from '@atc/modular-redux';
import createWalletId from './createWalletId';
import updateMyWalletInteractions from './updateMyWalletInteractions';
import updateUserTradeIn from './updateUserTradeIn';
import updateICOTradeIn from './updateICOTradeIn';
import updateCreditVerification from './updateCreditVerification';
import updateCreditAppDeals from './updateCreditAppDeals';
import setDealDetails from './setDealDetails';
import updateDealDetails from './updateDealDetails';
import updateDealReminders from './updateDealReminders';
import updateDealNotifications from './updateDealNotifications';
import resetDealNotifications from './resetDealNotifications';
import addHideReceiptListing from './addHideReceiptListing';
import removeHideReceiptListing from './removeHideReceiptListing';
import walletCentral from './walletCentral';
import updatePaymentsInfo from './updatePaymentsInfo';
import ensurePaymentsInfo from './ensurePaymentsInfo';
export default (function (duck, walletStorageService, ownerDetailsFetcher) {
  if (ownerDetailsFetcher === void 0) {
    ownerDetailsFetcher = () => {};
  }
  return {
    setPaymentsInfo: createAction(duck.types.SET_PAYMENT_INFO),
    ensurePaymentsInfo: ensurePaymentsInfo(duck),
    updatePaymentsInfo: updatePaymentsInfo(),
    updateMyWalletInteractions: updateMyWalletInteractions(duck),
    // Wallet Id related creators
    createWalletId: createWalletId(duck, walletStorageService),
    setWalletId: createAction(duck.types.SET_WALLET_ID),
    // Trade-In related creators
    updateUserTradeIn: updateUserTradeIn(duck, walletStorageService),
    updateICOTradeIn: updateICOTradeIn(duck, walletStorageService),
    // Credit releated creators
    updateCreditVerification: updateCreditVerification(duck, walletStorageService),
    updateCreditAppDeals: updateCreditAppDeals(duck, walletStorageService),
    // Deal related creators
    setDealDetails: setDealDetails(duck),
    updateDealDetails: updateDealDetails(duck),
    updateDealNotifications: updateDealNotifications(duck),
    updateDealReminders: updateDealReminders(duck),
    resetDealNotifications: resetDealNotifications(duck),
    addHideReceiptListing: addHideReceiptListing(duck),
    removeHideReceiptListing: removeHideReceiptListing(duck),
    goToWalletCentral: walletCentral(walletStorageService),
    getOwnerDetails: async payload => ownerDetailsFetcher(payload),
    updatePaymentPencils: createAction(duck.types.UPDATE_PAYMENT_PENCILS),
    updatePencilingPayments: createAction(duck.types.UPDATE_PENCILING_PAYMENTS),
    updatePenciledLatestPageId: createAction(duck.types.UPDATE_PENCILED_LATEST_PAGE_ID),
    updatePenciledVdpListings: createAction(duck.types.UPDATE_PENCILED_VDP_LISTINGS),
    updateMyWallet: createAction(duck.types.UPDATE_MY_WALLET),
    updateListingPayments: createAction(duck.types.UPDATE_LISTINGS_PAYMENTS),
    updateListingIncentives: createAction(duck.types.UPDATE_LISTINGS_INCENTIVES),
    updateListingLeasePayments: createAction(duck.types.UPDATE_LISTING_LEASE_PAYMENTS),
    updateListingCashPayments: createAction(duck.types.UPDATE_LISTING_CASH_PAYMENTS),
    updateIsLoading: createAction(duck.types.UPDATE_IS_LOADING)
  };
});